import EditOeuvreModal from "components/modal/EditOeuvreModal";
import { useAuth } from "hooks/auth";
import axios from "lib/axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
function ProposeWork() {
  const { user, isFetchingUser } = useAuth();
  const navigate = useNavigate();
  const [openEditOeuvreModal, setOpenEditOeuvreModal] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const params = useParams();

  const fetchItemToEdit = (id) => {
    axios
      .get(`/show-oeuvre/${id}`)
      .then((res) => {
        setItemToEdit(res.data.data);
        const work = res?.data?.data;
        setOpenEditOeuvreModal(true);
        console.log("itemToEdit :>> ", itemToEdit);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (!isFetchingUser && !user) {
      window.location.pathname = `/auth/login/url=${"test"}`;
    }
  }, [user]);

  useEffect(() => {
    if (!isFetchingUser && user && !itemToEdit) {
      fetchItemToEdit(params?.id);
    }
  }, [isFetchingUser]);

  return (
    <>
      {itemToEdit && ( 
        <EditOeuvreModal
          open={openEditOeuvreModal}
          setOpen={setOpenEditOeuvreModal}
          oeuvreToEdit={itemToEdit}
          onClose={() => {
            navigate('/')
            setOpenEditOeuvreModal(false)
          }}
        ></EditOeuvreModal>
      )}
    </>
  );
}

export default ProposeWork;
